<div class="content d-flex flex-column flex-column-fluid">
    <div class="toolbar mb-5">
        <div class="container-fluid d-flex flex-stack">
            <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">
                <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0">
                    <span><i class="fas fa-user text-success me-2" style="font-size: large;"></i><span></span> Profil
                        Bilgilerim</span>
                </h3>
            </div>
            <div class="d-flex align-items-center gap-2 gap-lg-3">
                <!-- <a [routerLink]="['yeni']" class="btn btn-sm btn-primary">Yeni Uygulama</a> -->
            </div>
        </div>
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-fluid">
            <loading [loader]="yukleniyor">
                <div class="card mb-5 col-md-8  offset-md-2 col-12" style="border-top: 4px  #77c2e9 solid;">
                    <div class="card-body p-9">

                        <div class="row mb-7">
                            <label class="col-lg-4 fw-bold text-info fs-6">Ad Soyad : </label>
                            <div class="col-lg-4">
                                <span class="fw-bolder fs-6 text-dark">{{kullanici?.adisoyadi}}</span>
                            </div>

                        </div>
                        <div class="row mb-7">
                            <label class="col-lg-4 fw-bold text-info fs-6">Doğum Tarihi : <span class="text-danger"> *
                                </span></label>
                            <div class="col-lg-8">
                                <span class="fw-bolder fs-6 text-dark">{{profilgelen?.dogumTarihi |
                                    date:'dd.MM.yyyy'}}</span>
                                <span class="badge badge-danger fs-6"
                                    *ngIf="!profilgelen?.dogumTarihi;">Girilmedi</span>
                            </div>

                        </div>
                        <div class="row mb-7">
                            <label class="col-lg-4 fw-bold text-info fs-6">
                                Telefon
                                <i class="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip"
                                    title="Telefon Bilgileri Zorunludur. Doğrulama yapılması gerekmektedir."></i>
                                <span class="text-danger"> *
                                </span>
                            </label>

                            <div class="col-lg-8 d-flex align-items-center text-info">
                                <span class="fw-bolder fs-6 "> {{ profilgelen?.telefon }} </span>
                                <span class="badge badge-success" style="margin-left: 8px;"
                                    *ngIf="profilgelen?.telDogrulama===true; else: noCorrect">Doğrulandı</span>

                            </div>
                            <ng-template #noCorrect>             
                                <span class="badge badge-danger fs-6"  *ngIf="!profilgelen?.telefon" style="margin-left: 8px;">Girilmedi</span>
                                <span class="badge badge-danger fs-6" style="margin-left: 8px;">Doğrulanmadı</span>
                            </ng-template>
                        </div>
                        <div class="row mb-7">
                            <label class="col-lg-4 fw-bold text-info fs-6">Öğrenci E-posta</label>
                            <div class="col-lg-8">
                                <span class="fw-bolder fs-6 text-dark"> {{ profilgelen?.ogrenciEPosta }} </span>
                                <span class="badge badge-danger fs-6" *ngIf="!profilgelen?.ogrenciEPosta;">Bulunamadı.</span>
                            </div>
                        </div>
                        <div class="row mb-7">
                            <label class="col-lg-4 fw-bold text-info fs-6">Kişisel E-Posta<span class="text-danger"> *
                                </span></label>
                            <div class="col-lg-8">
                                <span class="fw-bolder fs-6 text-dark"> {{ profilgelen?.ePosta }} </span>
                                <span class="badge badge-danger fs-6" *ngIf="!profilgelen?.ePosta;">Girilmedi</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" style="overflow-x:auto;overflow-y:auto;width: 100%;">
                        <!--begin::Item-->
                        <div
                            class="d-flex align-items-center bg-light-warning rounded p-5 mb-7 border-warning border border-dashed">
                            <!--begin::Icon-->
                           
                            <div class="col-md-9 col-xs-12 col-sm-12 me-2">       
                                <h4 class="text-gray-800 fw-bolder"> <i class="fas fa-exclamation-circle text-danger fs-1" style="font-size:larger;"></i>
                                    Bilgileriniz tamamlanmadan ve telefon numaranız doğrulanmadan
                                    talepte bulunulamazsınız ! <span style="color: blue;">Bilgilerimi Güncelle</span>  butonuna tıklayarak bilgilerinizi
                                    tamamlayınız.</h4>
                            </div>
                            <div class="col-md-3 col-xs-12 col-sm-12" style="overflow-x: auto;">
                                <a [routerLink]="[kullanici.kullanici_id]" class="btn btn-primary btn-hover-rise">
                                    <i class="far fa-id-badge"></i>
                                    Bilgilerimi Güncelle
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </loading>
        </div>
    </div>